import React, { useContext } from 'react';
import { string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { withHydrator, declareContexts } from '@thd-olt-component-react/hydrator';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryContext } from '@thd-nucleus/data-sources';
import { LoadingPlaceholder } from '../core/LoadingPlaceholder';
import { rvDataModel } from '../dataModel';
import RecentlyViewed from './RecentlyViewed';

const RecentlyViewedWrapperComponent = (props) => {
  const { schemaName } = props;
  const { isServer } = useContext(ExperienceContext);

  if (!isServer) {
    return (
      /* eslint-disable react/jsx-props-no-spreading */
      <RecentlyViewed {...props} schemaName={schemaName} />
    );
  }

  return null;
};

RecentlyViewedWrapperComponent.displayName = 'RecentlyViewedWrapper';

const propTypes = {
  schemaName: string.isRequired
};

const defaultProps = {};

const dataModel = rvDataModel;

RecentlyViewedWrapperComponent.propTypes = propTypes;
RecentlyViewedWrapperComponent.defaultProps = defaultProps;
RecentlyViewedWrapperComponent.dataModel = dataModel;

const HydratedRVRecs = withHydrator({
  delay: 1500,
  id: 'product-section-rv',
  placeholder: (<LoadingPlaceholder />),
  preserveCtxVal: 'clientStore',
  contexts: declareContexts([QueryContext])
}, RecentlyViewedWrapperComponent);

export const RecentlyViewedWrapper = withErrorBoundary(HydratedRVRecs);

RecentlyViewedWrapper.propTypes = propTypes;
RecentlyViewedWrapper.defaultProps = defaultProps;
RecentlyViewedWrapper.dataModel = dataModel;
